/**
 * Cross-fade through `container`'s children forever, one at a time.
 *
 * The children are stacked in one grid cell (see
 * components/lux-campaign-tags.scss), so the container keeps the width of the
 * widest child. They are hidden with `visibility` rather than `display: none`,
 * which would take them out of the layout and let the width jump.
 *
 * @param {HTMLElement} container - The element whose children rotate.
 * @param {number} fadeSpeed - Fade transition duration in ms.
 * @param {number} pauseSpeed - Pause duration between rotations in ms.
 * @param {number} [index=0] - The child index to show next.
 * @returns {void}
 */
function rotateLabel(container, fadeSpeed, pauseSpeed, index = 0) {
    const items = /** @type {HTMLElement[]} */ (Array.from(container.children));
    const current = items[index];
    if (!current) return;

    current.style.transition = `opacity ${fadeSpeed}ms`;
    current.style.visibility = "visible";
    current.style.opacity = "0";
    // Force a reflow so the transition above applies to the opacity change below.
    void current.offsetHeight;
    current.style.opacity = "1";

    setTimeout(() => {
        setTimeout(() => {
            current.style.opacity = "0";

            setTimeout(() => {
                current.style.visibility = "hidden";
                current.style.removeProperty("opacity");
                current.style.removeProperty("transition");
                rotateLabel(
                    container,
                    fadeSpeed,
                    pauseSpeed,
                    (index + 1) % items.length,
                );
            }, fadeSpeed);
        }, pauseSpeed);
    }, fadeSpeed);
}

document.querySelectorAll(".lux-campaign-tag.rotate").forEach((campaignTag) => {
    if (campaignTag instanceof HTMLElement) {
        rotateLabel(campaignTag, 500, 4000);
    }
});

export {};
